import { fullPhoneNumber } from 'helpers/common';
import * as React from 'react';
import { connect } from 'react-redux';
import { IStore } from 'redux/IStore';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { ICustomer } from 'models/shop/customer';
import renderIcon from 'helpers/renderIcon';

interface IOwnProps {
	customer?: ICustomer;
	size?: 'bigSize' | 'mediumSize' | 'smallSize';
	t?: (key: string) => string;
}

type IProps = IOwnProps & ReturnType<typeof stateToProps>;

const CustomerComponent = ({ t, customer, size }: IProps) => {
	const [imageDidNotLoad, setImageDidNotLoad] = React.useState(false);
	if (!customer) {
		return null;
	}

	const { name, picture, callingCodeKey, phoneNumber, email } = customer;

	return (
		<div className={`customer-card ${size ? size : 'mediumSize'}`}>
			<div className={'customer-card__picture-wrapper'}>
				{picture && !imageDidNotLoad ? (
					<img
						src={picture}
						alt={`${name}'s profile picture`}
						className="customer-card__picture-wrapper__picture"
						onError={() => setImageDidNotLoad(true)}
					/>
				) : (
					renderIcon('pfp_default2', 32, 32)
				)}
			</div>
			<div className="customer-card__info">
				<div className="customer-card__info__name">{name}</div>
				<div className="customer-card__info__contact-info">
					{callingCodeKey && phoneNumber && (
						<p className="customer-card__info__contact-info__phoneNumber">
							{fullPhoneNumber(t, callingCodeKey, phoneNumber)}
						</p>
					)}
					{email && <p className="customer-card__info__contact-info__email">{email}</p>}
				</div>
			</div>
		</div>
	);
};

const stateToProps = (state: IStore) => ({
	userPreferences: state.userPreferences,
	userShippingAddresses: state.userShippingAddresses,
});

export default translate(c.DEFAULT_TRANSLATION_NAMESPACE)(connect(stateToProps)(CustomerComponent));
